// Module
var code = `<footer class="footer"
	id="footer">


	<div class="footer__top">

		<div class="container container--space">
			<div class="row">
				<div class="col-md-3 ">
					<div class="footer__brand">

						<img class="footer__logo"
							ng-src="{{\$ctrl.footerData.logo}}"
							alt="Logo" />

						<p class="footer__download-text">
							{{\$ctrl.footerData.downloadText}}
						</p>

						<div class="footer__stores">
							<a class="footer__store"
								ng-repeat="store in \$ctrl.footerData.stores"
								ng-href="{{store.link}}"
								target="{{store.target}}"
								rel="{{store.rel}}">

								<img class="footer__store-img"
									ng-src="{{store.image}}"
									alt="{{store.alt}}">
							</a>
						</div>
					</div>
				</div>

				<div class="col-md-3 offset-lg-1">
					<div class="footer__legales">
						<h4 class="footer__title">
							{{\$ctrl.footerData.legales.title}}
						</h4>

						<ul class="footer__list">
							<li class="footer__item"
								ng-repeat="link in \$ctrl.footerData.legales.links">

								<a class="footer__link"
									target="_blank"
									ng-href="{{link.link}}">
									{{link.label}}
								</a>
							</li>
						</ul>
					</div>
				</div>

				<div class="col-md-3">

					<div class="footer__contact">
						<h4 class="footer__title">
							{{\$ctrl.footerData.contacto.title}}
						</h4>

						<ul class="footer__list">
							<li class="footer__item"
								ng-repeat="item in \$ctrl.footerData.contacto.items">

								<a class="footer__contact-link"
									ng-href="{{item.link || ''}}"
									ng-click="item.action && \$ctrl[item.action]()">

									<img ng-src="{{item.icon}}"
										ng-alt="{{item.label}}">
									<span class="footer__text">{{item.label}}</span>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-md-2 d-lg-flex justify-content-lg-end">
					<div class="footer__regulator">
						<img class="footer__regulator-logo"
							ng-src="{{\$ctrl.footerData.logoSuperintendencia}}"
							alt="Superintendencia">
					</div>
				</div>
			</div>
		</div>


	</div>


	<div class="footer__bottom">

		<div class="container container--space">
			<div class="row align-items-lg-center">
				<div class="col-lg-6 col-xl-8">
					<div class="footer__disclaimer"
						ng-bind-html="\$ctrl.footerData.disclaimer"></div>

				</div>
				<!-- <div class="col-lg-6 col-xl-4  d-lg-flex justify-content-lg-end">
					<div class="footer__social">

						<a class="footer__social-link"
							ng-repeat="social in \$ctrl.footerData.socialMedia.items"
							ng-href="{{social.link}}"
							target="{{social.target}}"
							rel="{{social.rel}}"
							aria-label="{{social.label}}">

							<img ng-src="{{social.icon}}"
								ng-alt="{{social-label}}">

						</a>

					</div>
				</div> -->
			</div>




		</div>



	</div>

</footer>`;
// Exports
export default code;